class AshCollectionToolbar extends HTMLElement {
  constructor() {
    super();
    this._onResize = this._onResize.bind(this);
  }

  connectedCallback() {
    this._wrappers = Array.from(this.querySelectorAll('.ash-toolbar__pills-wrapper'));
    this._descBlocks = Array.from(this.querySelectorAll('[data-ash-desc]'));

    if (!this._wrappers.length && !this._descBlocks.length) return;

    this._ro = new ResizeObserver(this._onResize);

    this._wrappers.forEach((w) => {
      this._ro.observe(w);
      const pills = w.querySelector('.ash-toolbar__pills');
      if (pills) this._ro.observe(pills);
    });

    this._descBlocks.forEach((block) => {
      this._ro.observe(block);
      const text = block.querySelector('[data-ash-desc-text]');
      if (text) this._ro.observe(text);
    });

    requestAnimationFrame(() => this._update());
  }

  disconnectedCallback() {
    if (this._ro) this._ro.disconnect();
  }

  _onResize() {
    this._update();
  }

  _update() {
    this._wrappers.forEach((wrapper) => {
      if (wrapper.offsetParent === null) {
        wrapper.classList.remove('is-overflow');
        return;
      }
      const pills = wrapper.querySelector('.ash-toolbar__pills');
      if (!pills) return;
      wrapper.classList.remove('is-overflow');
      const wrapperWidth = wrapper.clientWidth;
      const styles = getComputedStyle(pills);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const children = Array.from(pills.children);
      let total = 0;
      children.forEach((child, i) => {
        total += child.getBoundingClientRect().width;
        if (i < children.length - 1) total += gap;
      });
      if (total > wrapperWidth + 1) wrapper.classList.add('is-overflow');
    });

    this._descBlocks.forEach((block) => {
      const text = block.querySelector('[data-ash-desc-text]');
      const more = block.querySelector('[data-ash-desc-more]');
      if (!text || !more) return;
      if (block.offsetParent === null) return;
      const overflows = text.scrollHeight - text.clientHeight > 1;
      if (overflows) more.removeAttribute('hidden');
      else more.setAttribute('hidden', '');
    });
  }
}

if (!customElements.get('ash-collection-toolbar')) {
  customElements.define('ash-collection-toolbar', AshCollectionToolbar);
}
